'use client'

// src/constants/currency.ts
var ABSOLUTE_FALLBACK_CURRENCY = {
  id: "SAR",
  name: "SAR",
  shortCode: "SAR",
  symbol: "SAR",
  wallet_enabled: true
};

export {
  ABSOLUTE_FALLBACK_CURRENCY
};
//# sourceMappingURL=chunk-VWPCKV3U.mjs.map